const POSTGRES_UNSAFE_CONTROL_CHARS = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/g;
function stripPostgresUnsafeControlChars(value) {
    return value.replace(POSTGRES_UNSAFE_CONTROL_CHARS, "");
}
function sanitizeJsonStrings(value) {
    if (typeof value === "string") {
        return stripPostgresUnsafeControlChars(value);
    }
    if (Array.isArray(value)) {
        return value.map((item) => sanitizeJsonStrings(item));
    }
    if (value !== null && typeof value === "object") {
        const result = {};
        for (const [key, nested] of Object.entries(value)) {
            result[key] = sanitizeJsonStrings(nested);
        }
        return result;
    }
    return value;
}

export { sanitizeJsonStrings, stripPostgresUnsafeControlChars };
